import moment from "moment/moment";

export function localizedTimeToTest(time: any) {
  return moment.utc(time).local().format("hh:mma on MMMM Do, YYYY");
}


export function calculateDaysHoursYearsAgo(date: Date) {
  const now = new Date();
  const then = new Date(date);
  // console.log({now, date});
  const diff = now.getTime() - then.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
  if (years > 0) {
    return `${years} years ago`;
  }
  if (days > 0) {
    return `${days} days ago`;
  }
  if (hours > 0) {
    return `${hours} hours ago`;
  }
  if (minutes > 0) {
    return `${minutes} minutes ago`;
  }
  return `${seconds} seconds ago`;
};
